import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="groups--save"
export default class extends Controller {
  connect() {
    console.log("groups save connected");
    super.connect();
  }

  clicked = (element) => {
    console.log("clicked", element);
    event.preventDefault();
  };
}
